<kendo-grid
  #grid="kendoGrid"
  id="accVoucherGrid"
  class="acc-vocherdetail"
  [data]="gridData"
  [reorderable]="true"
  [resizable]="true"
  [pageSize]="state.take"
  [skip]="state.skip"
  [pageable]="false"
  [kendoGridSelectBy]="'RowNumber'"
  [selectedKeys]="mySelection"
  [columnMenu]="true"
  (cellClick)="onUserRowSelect($event)"
  (remove)="removeHandler($event)"
  (dblclick)="doubleclic($event)"
  (save)="saveCurrent()"
  (edit)="editHandler($event)"
  [rowSelected]="isRowSelected"
  [navigable]="true">
  <ng-template kendoGridToolbarTemplate>
    <ssg-button
      [disabled]="rowIsEditing || !isAdd"
      (click)="addHandler()"
      tooltip="ایجاد رکورد جدید(alt+shift+N)"
      icon="icon-NewRecord"
      class="btnstyle">
    </ssg-button>
    <ssg-button
      [disabled]="!rowIsEditing"
      (click)="cancelHandler()"
      tooltip="لغو تغییرات(Escape)"
      icon="icon-forbidden-2"
      class="btnstyle"></ssg-button>
    <ssg-button
      [disabled]="!mySelection || mySelection.length <= 0"
      (click)="copyHandler()"
      tooltip="کپی به حافظه(ctrl+C)"
      icon="icon-copyRow"
      class="btnstyle">
    </ssg-button>
    <ssg-button
      [disabled]="!hasdatForPaset()"
      (click)="pasetHandler()"
      tooltip="کپی از حافظه(ctrl+V)"
      icon="icon-Paste"
      class="btnstyle"></ssg-button>
    <ssg-button [disabled]="!movableUp()" (click)="moveUp()" tooltip="حرکت به بالا" icon="icon-rowUp" class="btnstyle"></ssg-button>
    <ssg-button [disabled]="!movableDown()" (click)="moveDown()" tooltip="حرکت به پایین" icon="icon-rowDown" class="btnstyle"></ssg-button>
    <ssg-button (click)="copyAll()" tooltip="کپی کل سند" icon="icon-copyAll" class="btnstyle"></ssg-button>
    <ssg-button [disabled]="rowIsEditing || editedRow === undefined" (click)="insertRow()" tooltip="درج ردیف" icon="icon-AddRow" class="btnstyle">
    </ssg-button>
    <ssg-button class="btnstyle" (click)="setDefaultColumnInfo()" data-tooltip="top" tooltip="تنظیمات پیشفرض" icon="icon-ic_Setting_24"></ssg-button>
    <!-- <ssg-button class="btnstyle" (click)="setDefaultColumnInfo()" data-tooltip="top" tooltip="انتخاب ستون" icon="icon-GridColumnMenu"></ssg-button> -->
    <span class="account-info" [innerHTML]="accountInfo"></span>
    <ssg-button (click)="triggerShowDetail()" class="detail-btn" icon="icon-eye1" label="نمایش جزئیات"> </ssg-button>
  </ng-template>

  <kendo-grid-command-column width="75" minResizableWidth="70" *ngIf="isDelete" title="عملیات" [columnMenu]="false">
    <ng-template kendoGridCellTemplate>
      <button kendoGridEditCommand [primary]="true" icon="edit" title="ویرایش"></button>
      <button *ngIf="isEdit" kendoGridSaveCommand [disabled]="formGroup?.invalid" icon="save" title="{{ isNew ? 'جدید' : 'تغییر' }}"></button>
      <button kendoGridRemoveCommand icon="delete" title="حذف"></button>
    </ng-template>
  </kendo-grid-command-column>

  <kendo-grid-column
    *ngFor="let column of setColumns(); let i = index"
    tabindex="{{ i }}"
    field="{{ column.name }}"
    title="{{ column.label }}"
    format="{{ column.format }}"
    [width]="column.columnWidth * 2"
    [hidden]="!column.listVisible"
    [minResizableWidth]="column.columnWidth * 2"
    [columnMenu]="true"
    [editable]="!column.disabled"
    editor="{{ column.textType == 'checkbox' ? 'boolean' : column.textType == 'number' ? 'numeric' : column.textType == 'date' ? 'date' : 'text' }}"
    filter="{{ column.textType == 'checkbox' ? 'boolean' : column.textType == 'number' ? 'numeric' : column.textType == 'date' ? 'date' : 'text' }}">
    <ng-template *ngIf="column.apiName" kendoGridCellTemplate let-dataItem>
      {{ getItemDisplayById(column.apiName, dataItem[column.name], column.displayMember, column.valueMember, dataItem, column.name) }}
    </ng-template>
    <ng-template *ngIf="hasAggregate(column.name)" kendoGridFooterTemplate>
      {{ getColumnAggregates(column.name) | number }}
    </ng-template>
    <ng-template *ngIf="column.textType === 'date'" kendoGridCellTemplate let-dataItem>
      {{ getDateValue(dataItem[column.name]) }}
    </ng-template>
    <ng-template
      *ngIf="column.apiName && !hasMultiColumns(column.columnsName)"
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
      let-isNew="isNew">
      <kendo-autocomplete
        [data]="LookupData[column.name]"
        [(value)]="dataItem[column.name]"
        (valueChange)="valueChange($event, column.name)"
        [suggest]="false"></kendo-autocomplete>
    </ng-template>
    <ng-template
      *ngIf="column.apiName && hasMultiColumns(column.columnsName)"
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
      let-isNew="isNew">
      <st-lookup
        name="{{ column.name }}"
        [group]="formGroup"
        [dataList]="LookupData[column.name]"
        apiName="{{ column.apiName }}"
        textFieldName="{{ column.displayMember }}"
        valueFieldName="{{ column.valueMember }}"
        [defaultHeight]="30"
        [shouldBeChangedData]="!column.name.includes('SubLedgerId') ? shouldBeChangedData : undefined"
        [onDataStateChange]="!column.name.includes('SubLedgerId') ? onDataStateChange : undefined"
        (onRowSelected)="selectionChange($event, column.name)"
        textColumnsName="{{ column.columnsName }}"
        [disabled]="false">
      </st-lookup>
    </ng-template>
    <ng-template *ngIf="column.textType === 'date'" kendoGridEditTemplate let-dataItem>
      <date-picker id="dp{{ column.name }}" [group]="formGroup" name="{{ column.name }}" [defaultHeight]="30" textType="{{ column.textType }}">
      </date-picker>
    </ng-template>
    <ng-template *ngIf="column.textType == 'checkbox'" kendoGridCellTemplate let-dataItem>
      <input type="checkbox" class="k-checkbox" [(checked)]="dataItem[column.name]" />
    </ng-template>
    <ng-template *ngIf="column.textType !== 'date' && !column.apiName" kendoGridGroupHeaderTemplate let-value="value">
      {{ value }}
    </ng-template>
    <button class="k-button" kendoGridFocusable>Update</button>
  </kendo-grid-column>
</kendo-grid>
